import { useEffect } from 'react';

/**
 * Adds listeners for array of media queries using `window.matchMedia`.
 * @param {string[]} mediaQueries array of media queries to match listeners
 * @param {({ media: string, matches: boolean }) => void} listener listener to be called
 */
const useMediaQueryList = (
  mediaQueries: string[],
  listener: ({ media, matches }: { media: string; matches: boolean }) => void,
): void => {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return () => { };
    }

    const mediaQueryList = mediaQueries
      .map((mediaQuery) => {
        const media = window.matchMedia(mediaQuery);
        if (typeof media.addEventListener === 'function') {
          media.addEventListener('change', listener);
        } else {
          // This is required on Safari 13 and lower
          media.addListener(listener);
        }
        return media;
      });
    mediaQueryList.forEach((mq) => listener(mq));

    return () => {
      mediaQueryList.forEach((media) => {
        if (typeof media.removeEventListener === 'function') {
          media.removeEventListener('change', listener);
        } else {
          // This is required on Safari 13 and lower
          media.removeListener(listener);
        }
      });
    };
  }, [mediaQueries, listener]);
};

export default useMediaQueryList;
